import { render, staticRenderFns } from "./DownloadProgress.vue?vue&type=template&id=9063f8a0&scoped=true"
import script from "./DownloadProgress.vue?vue&type=script&lang=js"
export * from "./DownloadProgress.vue?vue&type=script&lang=js"
import style0 from "./DownloadProgress.vue?vue&type=style&index=0&id=9063f8a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9063f8a0",
  null
  
)

export default component.exports